/**
 * @file
 * Behaviors for cards.
 */
/* eslint-disable max-len */

(function (Drupal) {
  /**
   * Setup and attach the card behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.card = {
    attach: function () {
      let elements = document.querySelectorAll('.dynamic-border[data-border-color]');
      
      if (elements.length > 0) {
        executeOnce('CardStyles', function () {
          elements.forEach(function(element) {
            let borderColor = element.getAttribute('data-border-color');
            element.style.borderTopColor = borderColor;
          });
        });
      }
    }
  };
})(Drupal);
